import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const ZakaznikDetail = lazy(() =>
  import('@/modules/zakaznici/ZakaznikDetail').then((m) => ({ default: m.ZakaznikDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/zakaznici/$id',
  component: () => (
    <Suspense fallback={null}>
      <ZakaznikDetail />
    </Suspense>
  ),
});
